import gql from 'graphql-tag';
import { graphql, compose } from 'react-apollo';

import ProgressReport from './components/ProgressReport';
import LoginHOC from '../../../../components/LoginHOC';

const ProgressReportQuery = gql`
query {
  getUserSalesReport {
    credits {
      in_progress
      total_purchased
    	forfeited
      completed
    }
    positions {
      date_applied
      job_opening {
        title
        company_name
      }
      status {
        id
        name
      }
      history {
        id
        users_to_job_openings_status_id
      }
    }
    user {
      id
      first_name
      last_name
    }
    top_industries {
      id
      name
    }
    summaries {
      advisor {
        first_name
      }
      summary_text
      summary_date
    }
    UpcomingSessions {
      scheduled_to
      id
      advisor {
        first_name
        last_name
        photo
        biography
      	job_positions {
          company {
            name
          }
          title:name
        }
        industries {
        	industry {
            name
          }
          value
          type
        }
        degrees {
          id
          university {
            name
          }
          major {
            name
          }
          degree_type {
            name
          }
        }
      }
      Industry {
        name
      }
      module {
        module_name
        student_module_summary
      }
      module_instance_status {
        id
        name
        category
      }
    }
    PreviousSessions {
      scheduled_to
      id
      Industry {
        name
      }
      module_component_instances {
        field_answers {
          value
          field {
            label
            description
            type
          }
        }
      }
      advisor {
        first_name
        last_name
        photo
        biography
      	job_positions {
          company {
            name
          }
          title:name
        }
        industries {
        	industry {
            name
          }
          value
          type
        }
        degrees {
          id
          university {
            name
          }
          major {
            name
          }
          degree_type {
            name
          }
        }
      }
      Industry {
        name
      }
      module {
        module_name
        student_module_summary
      }
      module_instance_status {
        id
        name
        category
      }
      zoom_recordings {
        file_url
        file_type
      }
    }
    scores {
      id
      skill_type_name
      order
      skills {
        id
        skill_name
        parent {
          skill_name
        }
        children {
          skill_name
          skill_scores {
            skill_score
          }
        }
      }
    }
  }
}
`;

export default (store) => ({
  path: '/',
  component: LoginHOC(compose(
    graphql(ProgressReportQuery, {
      name: 'ProgressReportData'
    })
  )(ProgressReport))
});



// WEBPACK FOOTER //
// ./src/routes/progress-report/routes/ProgressReport/index.js